import type { ModelDefinition } from "./types";

/** Bump together with `SYNC_SCHEMA_VERSION` in `api/src/sync/registry.ts`. */
export const SYNC_SCHEMA_VERSION = 6;

const modules = import.meta.glob<{ model: ModelDefinition }>("./models/*.ts", { eager: true });

/** Every `sync/models/*.ts` file exporting `model` is registered automatically. */
export const models = new Map<string, ModelDefinition>(
	Object.values(modules).map(({ model }) => [model.name, model]),
);

export const getModel = (name: string) => models.get(name);
